// extracted by mini-css-extract-plugin
module.exports = {"footerText":"Footer_footerText__2mihy","footer":"Footer_footer__2WC1p"};